import { AnyAction } from 'redux';
import { PROFILE_FAILURE, PROFILE_REQUEST, PROFILE_SUCCESS } from '../constants/editProfile.constant';

const initialState = {
    loading: false,
    data: [],
    errMsg: '',
};

export const editProfileReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                errMsg: '',
            };

        case PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };

        case PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                errMsg: action.payload,
            };

        default:
            return state;
    }
};
